export class Project {

    id: number;
    name: string;
    geographicZoneId: number;
    country: string;
    departureDate: Date;
    returnDate: Date;
    durationId: number;
}
